import "./PageHero.scss";

/**
 * Záhlavie zákazníckej obrazovky.
 *
 * PREČO SPOLOČNÝ KOMPONENT:
 *   Objednávka, moje objednávky, profil aj registrácia sú jedna cesta jedného
 *   človeka. Keď si každá obrazovka kreslila nadpis po svojom, pôsobilo to,
 *   akoby patrili inej aplikácii. Toto je jedno miesto, kde sa to rozhoduje.
 *
 * PREČO NIE FAREBNÝ PRUH:
 *   Plný červený pás cez celú šírku tlačil obsah dole a na každej obrazovke
 *   kričal rovnako nahlas. Namiesto neho je svetlé pozadie s jemnou bodkovou
 *   mriežkou, ktorá sa stráca do stratena. Červená ostáva len na tom, čo má
 *   vyniknúť: na štítku a na zvýraznenom slove v nadpise.
 *
 * `zvyraznene` je posledná časť nadpisu, ktorá ide červenou. Nadpis sa tak dá
 * čítať ako veta a nemusí mať ozdobnú ikonu, aby bol zaujímavý.
 */
function PageHero({ eyebrow, title, zvyraznene, lead, akcie, vedla, className = "" }) {
  return (
    <header className={`page-hero ${className}`.trim()}>
      <div className="page-hero__inner">
        <div className="page-hero__text">
          {eyebrow && <span className="page-hero__eyebrow">{eyebrow}</span>}
          <h1 className="page-hero__title">
            {title}
            {zvyraznene && <span className="page-hero__zvyraznene">{zvyraznene}</span>}
          </h1>
          {lead && <p className="page-hero__lead">{lead}</p>}
          {akcie && <div className="page-hero__akcie">{akcie}</div>}
        </div>
        {vedla && <div className="page-hero__vedla">{vedla}</div>}
      </div>
    </header>
  );
}

export default PageHero;
